import React, { useEffect, useRef, useState } from "react";
import Layout from "../../../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Loader from "../../../common/loader";
import Modal from "../../../common/modal";
import { toast } from "react-toastify";
import {
  addWeeklyOffer,
  deleteWeeklyOffer,
  fetchCouponCode,
  fetchWeeklyOffer,
  updateOfferStatus,
  updateWeeklyOffer,
} from "../../../redux/adminReducer";

function WeeklyOffers() {
  const { translations, dir } = useSelector((state) => state.language);
  const [newTitle, setNewTitle] = useState("");
  const [newOfferDesc, setNewOfferDesc] = useState("");
  const [newOfferPic, setNewOfferPic] = useState(null);
  const [newCouponId, setNewCouponId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 10;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [offerToDelete, setOfferToDelete] = useState(null);
  const [offerToUpdate, setOfferToUpdate] = useState(null);
  const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);
  const titleRef = useRef(null);
  const descRef = useRef(null);
  const dispatch = useDispatch();

  const offers = useSelector((state) => state.admin.offers?.data?.offer || []);
  const codes = useSelector((state) => state.admin.codes?.data || []);
  const totalOfferData = useSelector(
    (state) => state.admin.offers?.data?.totalData || 0
  );

  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.style.height = "auto";
      titleRef.current.style.height = `${titleRef.current.scrollHeight}px`;
    }
    if (descRef.current) {
      descRef.current.style.height = "auto";
      descRef.current.style.height = `${descRef.current.scrollHeight}px`;
    }
  }, [newTitle, newOfferDesc, isUpdateModalOpen, isAddModalOpen]);

  useEffect(() => {
    setLoading(true);
    dispatch(fetchCouponCode());
    dispatch(fetchWeeklyOffer(currentPage)).then(() => {
      setLoading(false);
    });
  }, [dispatch, currentPage]);

  const handleDeleteClick = (offer) => {
    setOfferToDelete(offer);
    setIsModalOpen(true);
  };

  const handleUpdateClick = (offer) => {
    setOfferToUpdate(offer);
    setNewTitle(offer.title);
    setNewOfferDesc(offer.description);
    setNewCouponId(offer.coupon_id?._id || "");
    setIsUpdateModalOpen(true);
  };

  const handleAddService = () => {
    if (newTitle) {
      setLoading(true);
      const formData = new FormData();
      formData.append("title", newTitle);
      if (newOfferDesc) formData.append("description", newOfferDesc);
      if (newOfferPic) formData.append("image", newOfferPic);
      if (newCouponId) formData.append("coupon_id", newCouponId);
      dispatch(addWeeklyOffer(formData))
        .then(() => {
          dispatch(fetchWeeklyOffer(currentPage));
          setLoading(false);
          toast.success(translations.toaster.weeklyOfferAddedSuccessfully);
        })
        .catch((error) => {
          console.error("Not added", error);
          setLoading(false);
        })
        .finally(() => {
          setIsAddModalOpen(false);
          setNewTitle("");
          setNewOfferDesc("");
          setNewOfferPic(null);
          setNewCouponId("");
        });
    }
  };

  const handleUpdateService = () => {
    if (!offerToUpdate) return;
    const formData = new FormData();
    formData.append("_id", offerToUpdate._id);
    if (newTitle.trim()) formData.append("title", newTitle.trim());
    if (newOfferDesc.trim())
      formData.append("description", newOfferDesc.trim());
    if (newOfferPic) formData.append("image", newOfferPic);
    if (newCouponId) formData.append("coupon_id", newCouponId);
    setLoading(true);
    console.log(formData);
    dispatch(updateWeeklyOffer(formData))
      .then(() => {
        dispatch(fetchWeeklyOffer(currentPage));
        toast.success(translations.toaster.weeklyOfferUpdatedSuccessfully);
      })
      .catch((err) => {
        console.error("Update failed", err);
      })
      .finally(() => {
        setLoading(false);
        setIsUpdateModalOpen(false);
        setNewTitle("");
        setOfferToUpdate(null);
        setNewOfferDesc("");
        setNewOfferPic(null);
        setNewCouponId("");
      });
  };
  const confirmDelete = () => {
    if (offerToDelete) {
      setLoading(true);
      dispatch(deleteWeeklyOffer(offerToDelete._id))
        .then(() => {
          dispatch(fetchWeeklyOffer(currentPage));
          toast.success(translations.toaster.WeeklyOfferdeletedSuccessfully);
        })
        .catch((error) => {
          console.error("Delete failed", error);
        })
        .finally(() => {
          setLoading(false);
          setIsModalOpen(false);
          setOfferToDelete(null);
        });
    }
  };

  const BASE_URL = process.env.REACT_APP_BASE_URL || "https://jeema.co/api/v2/";

  const [error, setError] = useState("");
  const handlePageChange = (event) => {
    const selectedPage = Number(event.target.value);

    if (selectedPage > totalPages) {
      setError(`Maximum value must be ${totalPages}`);
      // setCurrentPage(totalPages);
      return;
    }
    setCurrentPage(selectedPage);
    setError("");
  };
  const totalPages = Math.ceil(totalOfferData / itemsPerPage);
  const publishWeeklyOffer = (offerId) => {
    setLoading(true);
    const payload = {
      _id: offerId,
    };
    dispatch(updateOfferStatus(payload))
      .then(() => {
        dispatch(fetchWeeklyOffer(currentPage));
        setLoading(false);
        toast.success(translations.toaster.weeklyofferpublishedsuccessfully);
      })
      .catch((error) => {
        console.error("Failed to publish weekly offer", error);
        setLoading(false);
        toast.error(translations.toaster.failedtopublishweeklyoffer);
      })
      .finally(() => {
        setIsWarnModalOpen(false);
        setOfferToUpdate(null);
      });
  };

  return (
    <>
      <Layout>
        <div className="min-h-screen w-full  px-4 py-4">
          <section className="pt-1 grid grid-cols-2 items-center">
            <h1 className="text-xl font-bold text-white">
              {translations.weekly_offer.weeklyOffers}
              <small className="text-2xl font-semibold text-gray-600"> |</small>
              <small className="font-normal text-gray-600">
                {" "}
                {translations.weekly_offer.weeklyOffersManagement}
              </small>
            </h1>

            <div className="text-md text-white flex items-center justify-end space-x-1 ">
              <div className="rounded-full bg-[#5A189A] py-2 px-3">
                <Link
                  to="/"
                  className=" text-white  no-underline cursor-pointer"
                >
                  {translations.weekly_offer.dashboard}
                </Link>
                <span className="mx-1">/</span>
                <span className="text-green-300 ">
                  {translations.weekly_offer.weeklyOffer}
                </span>
              </div>
            </div>
          </section>
          <div className="p-4 w-full bg-gray-800 shadow-xl rounded mt-5">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-2xl font-semibold text-white">
                    {translations.weekly_offer.weeklyOfferList}
                  </h2>
                  <button
                    onClick={() => setIsAddModalOpen(true)}
                    className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded"
                  >
                    {translations.weekly_offer.addWeeklyOffer}
                  </button>
                </div>
                {offers.length === 0 ? (
                  <div className="flex h-64 items-center justify-center text-gray-500 dark:text-gray-400">
                    <p className="text-xl">
                      {translations.weekly_offer.noData}
                    </p>
                  </div>
                ) : (
                  <div className="grid  md:grid lg:grid  overflow-x-auto ">
                    <table className="min-w-full divide-y divide-gray-600 text-white">
                      <thead className="bg-[#5A189A] text-center">
                        <tr>
                          <th className="px-4 py-2">
                            {translations.weekly_offer.offerPic}
                          </th>
                          <th className="px-4 py-2">
                            {translations.weekly_offer.title}
                          </th>
                          <th className="px-4 py-2">
                            {translations.weekly_offer.code}
                          </th>
                          <th className="px-4 py-2">
                            {translations.weekly_offer.description}
                          </th>
                          <th className="px-4 py-2">
                            {translations.weekly_offer.status}
                          </th>
                          <th className="px-4 py-2">
                            {translations.weekly_offer.actions}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {offers.map((offer, index) => (
                          <tr key={index} className=" text-center">
                            <td className="px-4 py-2 flex justify-center">
                              <img
                                src={`${BASE_URL}${encodeURIComponent(
                                  offer.image
                                )}`}
                                alt={`registration_document_${index}`}
                                className="h-10 w-10 object-cover rounded-lg"
                              />
                            </td>
                            <td className="px-4 py-2">{offer.title}</td>
                            <td className="px-4 py-2">
                              {offer?.coupon_id?.code}
                            </td>
                            <td className="px-4 py-2">{offer.description}</td>
                            <td className="px-4 py-2">
                              <p
                                className={`rounded-full px-3.5 mt-3 text-body-sm font-medium capitalize ${
                                  offer.isPublished === true
                                    ? "bg-[#D34053]/[0.08] text-green-400"
                                    : "bg-[#D34053]/[0.08] text-[#e1da5a] cursor-pointer"
                                }`}
                                title={`${
                                  offer.isPublished === true
                                    ? ""
                                    : "Publish Offer"
                                }`}
                                onClick={() => {
                                  setIsWarnModalOpen(true);
                                  setOfferToUpdate(offer);
                                }}
                              >
                                {offer.isPublished === true
                                  ? translations.weekly_offer.publish
                                  : translations.weekly_offer.notPublished}
                              </p>
                            </td>
                            <td className="px-4 py-3 flex justify-center">
                              <button
                                onClick={() => handleUpdateClick(offer)}
                                className="text-green-600 hover:text-green-300 px-2  text-xl"
                              >
                                <FaRegEdit />
                              </button>
                              <button
                                onClick={() => handleDeleteClick(offer)}
                                className="text-red-700  hover:text-red-500  text-2xl"
                              >
                                <MdDelete />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {/* Pagination Controls */}
                    <div className="mt-4 flex justify-between text-white">
                      <svg
                        className={`${
                          currentPage === 1
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        width={24}
                        height={24}
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        aria-disabled={currentPage === 1}
                      >
                        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                      </svg>
                      <span>
                        {translations.salon_request.page}
                        {totalPages > 1 ? (
                          <input
                            type="number"
                            name=""
                            id="pagination-jump"
                            className={
                              error
                                ? `mx-2 rounded-md border  ps-1 border-red  bg-gray-800 text-white shadow-card focus:border-primary`
                                : `mx-2 rounded-md border border-gray-300 ps-1  bg-gray-800 text-white shadow-card focus:border-primary`
                            }
                            min={1}
                            max={totalPages}
                            defaultValue={currentPage}
                            onChange={(e) => e.target.value}
                            onBlur={(e) => handlePageChange(e)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handlePageChange(e);
                              }
                            }}
                          />
                        ) : (
                          <span className="mx-1">{currentPage}</span>
                        )}
                        {translations.salon_request.of} {totalPages}
                      </span>
                      <svg
                        className={`${
                          currentPage === totalPages
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 320 512"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        aria-disabled={currentPage === totalPages}
                      >
                        <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                      </svg>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Layout>
      {/* delete modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        width="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] xl:w-[40%] max-w-xl"
      >
        <div className="w-full px-4 sm:px-6 md:px-8 py-6 text-white mx-auto">
          <h2 className="text-xl font-semibold mb-4 text-red-600 text-center">
            {translations.weekly_offer.confirmDelete}
          </h2>

          <p className="mb-6 text-center">
            {translations.weekly_offer.warning}
          </p>

          <div className="flex flex-col sm:flex-row justify-center sm:justify-end gap-3">
            <button
              className="w-full sm:w-auto bg-gray-500 px-4 py-2 rounded hover:bg-gray-400"
              onClick={() => setIsModalOpen(false)}
            >
              {translations.weekly_offer.cancel}
            </button>
            <button
              className="w-full sm:w-auto bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
              onClick={() => {
                confirmDelete();
                setIsModalOpen(false);
              }}
            >
              {translations.weekly_offer.delete}
            </button>
          </div>
        </div>
      </Modal>

      {/* offer add modal */}
      <Modal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        width="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] xl:w-[50%] max-w-2xl"
      >
        <div className="w-full px-4 sm:px-6 md:px-8 py-6 mx-auto">
          <h3 className="text-xl text-center text-white mb-6">
            {translations.weekly_offer.addWeeklyOffer}
          </h3>

          {/* Title */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.weekly_offer.title}
          </label>
          <input
            type="text"
            onChange={(e) => setNewTitle(e.target.value)}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          />

          {/* Description */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.weekly_offer.description}
          </label>
          <textarea
            onChange={(e) => setNewOfferDesc(e.target.value)}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3 resize-none"
          />

          {/* Coupon Code */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.weekly_offer.code}
          </label>
          <select
            onChange={(e) => setNewCouponId(e.target.value)}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          >
            <option value="">{translations.weekly_offer.selectacoupon}</option>
            {codes.map((coupon) => (
              <option key={coupon._id} value={coupon._id}>
                {coupon.code}
              </option>
            ))}
          </select>

          {/* Offer Picture */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.weekly_offer.offerPicture}
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setNewOfferPic(e.target.files?.[0] || null)}
            className="w-full text-white mb-3"
          />

          <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">
            <button
              onClick={() => {
                setIsAddModalOpen(false);
                setNewTitle("");
                setNewOfferDesc("");
                setNewOfferPic(null);
              }}
              className="w-full sm:w-auto px-4 py-2 rounded bg-gray-600 text-white hover:bg-gray-500"
            >
              {translations.weekly_offer.cancel}
            </button>
            <button
              onClick={handleAddService}
              className="w-full sm:w-auto px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
            >
              {translations.weekly_offer.submit}
            </button>
          </div>
        </div>
      </Modal>

      {/* offer update modal */}
      <Modal
        isOpen={isUpdateModalOpen}
        onClose={() => setIsUpdateModalOpen(false)}
        width="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] xl:w-[50%] max-w-2xl"
      >
        <div className="w-full px-4 sm:px-6 md:px-8 py-6 mx-auto">
          <h3 className="text-xl text-center mb-4 text-white">
            {translations.weekly_offer.updateWeeklyOffer}
          </h3>

          {/* Title */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.weekly_offer.Title}
          </label>
          <textarea
            ref={titleRef}
            value={newTitle}
            onChange={(e) => {
              setNewTitle(e.target.value);
              e.target.style.height = "auto";
              e.target.style.height = `${e.target.scrollHeight}px`;
            }}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3 overflow-hidden resize-none"
          />

          {/* Description */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.weekly_offer.description}
          </label>
          <textarea
            ref={descRef}
            value={newOfferDesc}
            onChange={(e) => {
              setNewOfferDesc(e.target.value);
              e.target.style.height = "auto";
              e.target.style.height = `${e.target.scrollHeight}px`;
            }}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3 overflow-hidden resize-none"
          />

          {/* Coupon Code */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.weekly_offer.code}
          </label>
          <select
            value={newCouponId}
            onChange={(e) => setNewCouponId(e.target.value)}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          >
            <option value="">
              {translations.weekly_offer.selectacoupon || "Select a coupon"}
            </option>
            {codes.map((coupon) => (
              <option key={coupon._id} value={coupon._id}>
                {coupon.code}
              </option>
            ))}
          </select>

          {/* Offer Picture */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.weekly_offer.offerPicture}
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setNewOfferPic(e.target.files?.[0] || null)}
            className="w-full text-white mb-3"
          />

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">
            <button
              onClick={() => {
                setIsUpdateModalOpen(false);
                setNewTitle("");
                setNewOfferDesc("");
                setNewOfferPic(null);
              }}
              className="w-full sm:w-auto px-4 py-2 rounded bg-gray-600 text-white hover:bg-gray-500"
            >
              {translations.weekly_offer.cancel}
            </button>
            <button
              onClick={handleUpdateService}
              className="w-full sm:w-auto px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
            >
              {translations.weekly_offer.update}
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isWarnModalOpen}
        onClose={() => {
          setIsWarnModalOpen(false);
          setOfferToUpdate(null);
        }}
        width="w-[450px]"
      >
        <div className="p-6">
          <h2 className="mb-6 text-xl font-bold text-white">
            {translations.weekly_offer.confirmPublishWeeklyOffer}
          </h2>

          <div className="mb-4 rounded-md border border-blue-300 bg-blue-100 p-4 text-blue-800">
            <strong>{translations.weekly_offer.note}:</strong>{" "}
            {
              translations.weekly_offer
                .Oncepublishedtheweeklyofferwillbevisibletousersandcannotbeedited
            }
            .
          </div>

          <div className="flex justify-end gap-2 text-end">
            <button
              onClick={() =>
                publishWeeklyOffer(offerToUpdate ? offerToUpdate._id : "")
              }
              className="basis-1/4 rounded-md bg-green-600 px-4 py-2 text-white hover:bg-green-700"
            >
              {translations.weekly_offer.publish}
            </button>

            <button
              onClick={() => {
                setIsWarnModalOpen(false);
                setOfferToUpdate(null);
              }}
              className="basis-1/4 rounded-md bg-gray-600 px-4 py-2 text-white hover:bg-gray-700"
            >
              {translations.weekly_offer.cancel}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default WeeklyOffers;
